export default __webpack_public_path__ + "static/media/panel6.532048f5.png";